<template>
    <!-- <UpdateModal /> -->
  <header
    v-if="
      $store.state.header &&
      $store.state.header_enabled &&
      !$store.state.reportForming.previewMode
    "
    :class="{ hidden: $store.state.header_hidden }"
  >

        <div class="logo" @click="closeMobileDrawers" v-show="!isMobileWindow() ? true : !$store.state.showingHeaderSearchBar">
          <router-link to="/">
            <img
              ref="logo"
              :src="
                $store.state.api_uploads_link + $store.state.system_settings['logo']
              "
              alt="Logo"
              @error="replaceLogo"
            />
          </router-link>
        </div>
        <div class="user-info-container" >
            <div class="user-info-wrapper">
                <div class="user-name" v-if="$store.state.user_name && $store.state.user_name.length > 0"> 
                    {{ $store.state.user_name }} {{ $store.state.user_last_name ? $store.state.user_last_name : '' }}
                </div>
                <div class="user-email" v-if="$store.state.user_email && $store.state.user_email.length > 0">
                    {{ $store.state.user_email }}
                </div>
            </div>
            <div class="edit-info" @click="goToEditInfoPage">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.33004 6.41667C7.43156 6.41667 5.89254 7.95569 5.89254 9.85417C5.89254 11.7526 7.43156 13.2917 9.33004 13.2917C11.2285 13.2917 12.7675 11.7526 12.7675 9.85417C12.7675 7.95569 11.2285 6.41667 9.33004 6.41667ZM7.26754 9.85417C7.26754 8.71508 8.19095 7.79167 9.33004 7.79167C10.4691 7.79167 11.3925 8.71508 11.3925 9.85417C11.3925 10.9933 10.4691 11.9167 9.33004 11.9167C8.19095 11.9167 7.26754 10.9933 7.26754 9.85417Z" fill="#1C274D"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.30688 2.51258e-07C8.89946 -6.46917e-06 8.55934 -1.20971e-05 8.28011 0.0190395C7.98944 0.0388721 7.71487 0.081628 7.44868 0.191888C6.83101 0.447737 6.34027 0.938478 6.08442 1.55615C5.95122 1.87771 5.91515 2.21661 5.90137 2.58497C5.8903 2.88108 5.74086 3.12813 5.52033 3.25546C5.29979 3.38278 5.01112 3.38867 4.74915 3.25021C4.42325 3.07795 4.11172 2.93974 3.76663 2.89431C3.10379 2.80705 2.43342 2.98667 1.90301 3.39367C1.67443 3.56907 1.50012 3.78547 1.33761 4.02729C1.18149 4.25958 1.01144 4.55413 0.807734 4.90698L0.784583 4.94707C0.580867 5.29991 0.410804 5.59445 0.28769 5.8458C0.159528 6.10745 0.0592731 6.3666 0.0216656 6.65226C-0.0655997 7.31511 0.114024 7.98547 0.521021 8.51588C0.732879 8.79198 1.00829 8.99265 1.32036 9.18873C1.57132 9.34642 1.71059 9.59944 1.71058 9.85415C1.71056 10.1088 1.5713 10.3618 1.32036 10.5195C1.00825 10.7156 0.73281 10.9163 0.520932 11.1924C0.113934 11.7228 -0.0656895 12.3932 0.0215759 13.056C0.0591833 13.3417 0.159438 13.6008 0.2876 13.8625C0.410713 14.1138 0.580773 14.4084 0.784485 14.7612L0.807642 14.8013C1.01135 15.1541 1.1814 15.4487 1.33752 15.681C1.50003 15.9228 1.67434 16.1392 1.90292 16.3146C2.43333 16.7216 3.1037 16.9012 3.76654 16.814C4.11161 16.7685 4.42312 16.6303 4.749 16.4581C5.01101 16.3196 5.29972 16.3255 5.52028 16.4528C5.74084 16.5802 5.8903 16.8273 5.90138 17.1234C5.91515 17.4918 5.95123 17.8306 6.08442 18.1522C6.34027 18.7699 6.83101 19.2606 7.44868 19.5164C7.71487 19.6267 7.98944 19.6695 8.28011 19.6893C8.55934 19.7083 8.89946 19.7083 9.30688 19.7083H9.35318C9.7606 19.7083 10.1007 19.7083 10.3799 19.6893C10.6706 19.6695 10.9452 19.6267 11.2114 19.5164C11.8291 19.2606 12.3198 18.7699 12.5756 18.1522C12.7088 17.8306 12.7449 17.4917 12.7587 17.1233C12.7698 16.8272 12.9192 16.5802 13.1397 16.4528C13.3603 16.3255 13.649 16.3196 13.911 16.458C14.2369 16.6303 14.5484 16.7685 14.8934 16.8139C15.5563 16.9012 16.2266 16.7215 16.757 16.3145C16.9856 16.1391 17.1599 15.9227 17.3225 15.6809C17.4786 15.4486 17.6486 15.1541 17.8523 14.8013L17.8755 14.7612C18.0792 14.4084 18.2493 14.1137 18.3724 13.8624C18.5005 13.6008 18.6008 13.3416 18.6384 13.0559C18.7257 12.3931 18.546 11.7227 18.139 11.1923C17.9272 10.9162 17.6517 10.7155 17.3396 10.5194C17.0887 10.3618 16.9495 10.1088 16.9495 9.85412C16.9495 9.59947 17.0887 9.34653 17.3396 9.18889C17.6518 8.99277 17.9272 8.79208 18.1391 8.51594C18.5461 7.98553 18.7257 7.31517 18.6385 6.65233C18.6009 6.36667 18.5006 6.10751 18.3725 5.84586C18.2494 5.59453 18.0793 5.30001 17.8756 4.94721L17.8524 4.90708C17.6487 4.55423 17.4787 4.25964 17.3225 4.02735C17.16 3.78553 16.9857 3.56913 16.7571 3.39373C16.2267 2.98673 15.5564 2.80711 14.8935 2.89438C14.5485 2.93981 14.2369 3.078 13.9111 3.25024C13.6491 3.38872 13.3603 3.38283 13.1398 3.25549C12.9192 3.12815 12.7698 2.88106 12.7587 2.58491C12.7449 2.21658 12.7088 1.8777 12.5756 1.55615C12.3198 0.938477 11.8291 0.447737 11.2114 0.191888C10.9452 0.0816282 10.6706 0.0388721 10.3799 0.0190395C10.1007 -1.20971e-05 9.7606 -6.46917e-06 9.35318 2.51258e-07H9.30688ZM7.97487 1.46222C8.0456 1.43293 8.15304 1.40591 8.37371 1.39085C8.60055 1.37537 8.89351 1.375 9.33003 1.375C9.76655 1.375 10.0595 1.37537 10.2863 1.39085C10.507 1.40591 10.6145 1.43293 10.6852 1.46222C10.9659 1.57852 11.189 1.80158 11.3053 2.08234C11.342 2.1709 11.3724 2.30897 11.3846 2.63631C11.4118 3.36265 11.7867 4.06201 12.4523 4.44627C13.1178 4.83054 13.911 4.80553 14.5536 4.46589C14.8432 4.31282 14.9779 4.27013 15.073 4.25761C15.3743 4.21795 15.679 4.2996 15.9201 4.48459C15.9808 4.53119 16.0579 4.61074 16.1813 4.79431C16.3081 4.98302 16.4549 5.23655 16.6732 5.61459C16.8915 5.99262 17.0376 6.24652 17.1376 6.45071C17.2349 6.64934 17.2653 6.7559 17.2752 6.8318C17.3149 7.13309 17.2333 7.4378 17.0483 7.6789C16.9899 7.75495 16.8855 7.85033 16.6081 8.02462C15.9927 8.41129 15.5745 9.08559 15.5745 9.85405C15.5744 10.6226 15.9926 11.297 16.6081 11.6837C16.8855 11.858 16.9898 11.9533 17.0482 12.0294C17.2332 12.2705 17.3148 12.5752 17.2752 12.8765C17.2652 12.9524 17.2348 13.0589 17.1376 13.2576C17.0375 13.4618 16.8914 13.7156 16.6731 14.0937C16.4549 14.4717 16.3081 14.7252 16.1812 14.914C16.0579 15.0975 15.9807 15.1771 15.92 15.2237C15.6789 15.4087 15.3742 15.4903 15.0729 15.4507C14.9779 15.4381 14.8431 15.3955 14.5535 15.2424C13.9109 14.9027 13.1177 14.8778 12.4521 15.2621C11.7867 15.6463 11.4118 16.3457 11.3846 17.072C11.3724 17.3993 11.342 17.5374 11.3053 17.626C11.189 17.9068 10.966 18.1298 10.6852 18.2461C10.6145 18.2754 10.507 18.3024 10.2863 18.3175C10.0595 18.333 9.76655 18.3333 9.33003 18.3333C8.89351 18.3333 8.60055 18.333 8.37371 18.3175C8.15304 18.3024 8.0456 18.2754 7.97487 18.2461C7.69411 18.1298 7.47105 17.9068 7.35475 17.626C7.31807 17.5374 7.28766 17.3994 7.27542 17.072C7.24825 16.3457 6.87334 15.6463 6.20778 15.2621C5.54222 14.8778 4.7491 14.9028 4.10649 15.2424C3.81688 15.3955 3.68211 15.4382 3.58707 15.4507C3.28578 15.4904 2.98107 15.4087 2.73997 15.2237C2.67924 15.1771 2.60211 15.0976 2.47874 14.914C2.35192 14.7253 2.20512 14.4718 1.98686 14.0938C1.7686 13.7157 1.62244 13.4618 1.52242 13.2576C1.42513 13.059 1.3948 12.9524 1.38481 12.8765C1.34515 12.5752 1.42679 12.2705 1.61179 12.0294C1.67015 11.9534 1.77451 11.858 2.05189 11.6837C2.66732 11.2971 3.08554 10.6227 3.08558 9.85423C3.08562 9.08564 2.66739 8.41122 2.0519 8.02448C1.77458 7.85024 1.67023 7.75488 1.61188 7.67883C1.42688 7.43774 1.34524 7.13303 1.3849 6.83173C1.39489 6.75584 1.42522 6.64927 1.52251 6.45064C1.62253 6.24645 1.76869 5.99256 1.98695 5.61452C2.20521 5.23648 2.35201 4.98296 2.47883 4.79425C2.6022 4.61067 2.67933 4.53113 2.74006 4.48453C2.98116 4.29953 3.28587 4.21788 3.58716 4.25755C3.68221 4.27006 3.81698 4.31276 4.10662 4.46585C4.74921 4.80549 5.54229 4.83049 6.20782 4.44625C6.87335 4.06201 7.24825 3.36267 7.27541 2.63635C7.28766 2.30898 7.31806 2.17091 7.35475 2.08234C7.47105 1.80158 7.69411 1.57852 7.97487 1.46222Z" fill="#1C274D"/>
                </svg>
            </div>
        </div>
      <transition name="fade">
        <div
          class="search--wrapper"
          v-if="
            isMobileWindow()
              ? ['main', 'home'].includes(currentRouteName) &&
                $store.state.certificates &&
                !$store.state.certificates.isOpenedCert()
              : ['main', 'home'].includes(currentRouteName) &&
                !$store.state.showHomePageSearchInput &&
                $store.state.homePageSearchLoaded
          "
          @click="$refs.search.focus()"
        ></div>
      </transition>
      <div class="right-menu-section" v-if="!isMobileWindow()">
        <div class="platform-switcher" v-if="$store.state.connectedLMSes && $store.state.connectedLMSes.length >1">
          <div class="border-left">
            <CustomDropdown
                  :list="$store.state.connectedLMSes"
                  key-label="lms_key"
                  value-label="name"
                  :compareChosen="selectedLMS"
                  :options="{
                      closeOnClick: true,
                      checkbox: false,
                      customDDWidth: '100%',
                      customMaxHeight: '300px',
                      initial: selectedLMS && selectedLMS.name ? selectedLMS.name : '',
                      containerClass: 'platform-switch-dropdown',
                      showCreateNewBtn:false
                  }"
                  @elClicked="switchPlatform($event)"
              >
                  <template v-slot:arrow >
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.933058 1.05806C1.17714 0.813981 1.57286 0.813981 1.81694 1.05806L6.375 5.61612L10.9331 1.05806C11.1771 0.813981 11.5729 0.813981 11.8169 1.05806C12.061 1.30214 12.061 1.69786 11.8169 1.94194L6.81694 6.94194C6.57286 7.18602 6.17714 7.18602 5.93306 6.94194L0.933058 1.94194C0.688981 1.69786 0.688981 1.30214 0.933058 1.05806Z" fill="#7D7D7D"/>
                    </svg>
                  </template>
              </CustomDropdown>
          </div>
        </div>
        <div class="platform-switcher text-only" v-else-if="($store.state.system_settings.siblingPlatforms && $store.state.system_settings.siblingPlatforms.length >0) && $store.state.system_settings.current_platform_name">
            {{ $store.state.system_settings.current_platform_name	 }}
        </div>
        <div class="cert-button-container">
          <div class="cert-button" @click="openCertificates()">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.57927 4.55414e-07H12.3374C13.4771 -1.67306e-05 14.3957 -3.05908e-05 15.1181 0.0971033C15.8682 0.19795 16.4998 0.413695 17.0014 0.915292C17.503 1.41689 17.7187 2.04845 17.8196 2.79854C17.9167 3.52102 17.9167 4.43962 17.9167 5.57928V9.00406C17.9167 10.1437 17.9167 11.0623 17.8196 11.7848C17.7187 12.5349 17.503 13.1664 17.0014 13.668C16.5864 14.083 16.0807 14.3038 15.4884 14.4244C15.1866 14.4859 14.852 14.5232 14.4835 14.5461C14.4854 14.5503 14.4872 14.5546 14.4891 14.5589C14.7165 15.0925 14.5224 15.7132 14.0058 16.006C13.8505 16.0941 13.6835 16.1258 13.5667 16.1439C13.4447 16.1628 13.2922 16.1777 13.1228 16.1943L13.1063 16.1959C12.9973 16.2066 12.9355 16.2128 12.8895 16.2193C12.8687 16.2223 12.8576 16.2245 12.8532 16.2255C12.8402 16.2306 12.8314 16.2369 12.8258 16.2424C12.8215 16.2464 12.8184 16.2505 12.8161 16.2547C12.8152 16.2594 12.8138 16.267 12.812 16.2782C12.8055 16.3202 12.7993 16.3775 12.7881 16.4826L12.7862 16.4998C12.7691 16.661 12.7533 16.8092 12.7332 16.9284C12.7138 17.0433 12.679 17.2128 12.5822 17.3698C12.2703 17.8755 11.6478 18.0319 11.1355 17.8312C10.9756 17.7686 10.8473 17.6665 10.7547 17.5869C10.6599 17.5054 10.5482 17.3983 10.423 17.2783L8.95833 15.8741L7.49363 17.2783C7.3685 17.3983 7.25678 17.5054 7.16192 17.5869C7.06934 17.6665 6.94104 17.7686 6.78114 17.8312C6.26891 18.0319 5.64639 17.8755 5.3345 17.3698C5.23769 17.2128 5.20287 17.0433 5.18348 16.9284C5.16337 16.8092 5.14759 16.6609 5.13043 16.4998L5.1286 16.4826C5.1174 16.3775 5.11113 16.3202 5.10463 16.2782C5.10289 16.267 5.10148 16.2594 5.10054 16.2547C5.09824 16.2505 5.09513 16.2464 5.0909 16.2424C5.08523 16.2369 5.07645 16.2306 5.06345 16.2255C5.05905 16.2245 5.04802 16.2223 5.02712 16.2193C4.98118 16.2128 4.91932 16.2066 4.81036 16.1959L4.79385 16.1943C4.62448 16.1777 4.47198 16.1628 4.34994 16.1439C4.23314 16.1258 4.06612 16.0941 3.91082 16.006C3.39423 15.7132 3.20016 15.0925 3.42759 14.5589C3.42943 14.5546 3.43131 14.5503 3.43321 14.546C3.10098 14.5254 2.79762 14.4932 2.52196 14.4425C1.8903 14.3265 1.35273 14.1055 0.915293 13.668C0.413695 13.1664 0.19795 12.5349 0.0971034 11.7848C-3.05908e-05 11.0623 -1.67306e-05 10.1437 4.55414e-07 9.00406V5.57927C-1.67306e-05 4.43961 -3.05908e-05 3.52101 0.0971033 2.79854C0.19795 2.04845 0.413695 1.41689 0.915292 0.915293C1.41689 0.413695 2.04845 0.19795 2.79854 0.0971034C3.52101 -3.05908e-05 4.43961 -1.67306e-05 5.57927 4.55414e-07ZM4.56908 13.3302L5.24892 12.6784L5.8399 12.0874C5.94511 10.4567 7.30106 9.16667 8.95833 9.16667C10.6156 9.16667 11.9716 10.4567 12.0768 12.0874L12.6677 12.6784L13.3851 13.3662L13.3847 13.3298C14.207 13.3211 14.7931 13.2903 15.239 13.1995C15.6678 13.1122 15.9242 12.9774 16.1175 12.7842C16.3481 12.5535 16.4985 12.2297 16.5807 11.6182C16.6653 10.9888 16.6667 10.1545 16.6667 8.95833V5.625C16.6667 4.42882 16.6653 3.59456 16.5807 2.9651C16.4985 2.35362 16.3481 2.02981 16.1175 1.79918C15.8869 1.56854 15.563 1.41817 14.9516 1.33596C14.3221 1.25133 13.4878 1.25 12.2917 1.25H5.625C4.42882 1.25 3.59456 1.25133 2.9651 1.33596C2.35362 1.41817 2.02981 1.56854 1.79918 1.79918C1.56854 2.02981 1.41817 2.35362 1.33596 2.9651C1.25133 3.59456 1.25 4.42882 1.25 5.625V8.95833C1.25 10.1545 1.25133 10.9888 1.33596 11.6182C1.41817 12.2297 1.56854 12.5535 1.79918 12.7842C2.00205 12.987 2.27545 13.1264 2.74779 13.2131C3.19644 13.2955 3.77552 13.3223 4.56908 13.3302ZM11.8049 13.5829C11.4661 14.3286 10.8429 14.9178 10.0737 15.2117L11.2766 16.365C11.3833 16.4672 11.4591 16.5397 11.5182 16.5935C11.5258 16.5304 11.5343 16.4516 11.5451 16.3502C11.5466 16.3364 11.548 16.3224 11.5495 16.308C11.5654 16.155 11.5842 15.9738 11.6474 15.8101C11.7874 15.4476 12.0791 15.1738 12.4387 15.0461C12.6007 14.9887 12.7799 14.9715 12.9412 14.956C12.9558 14.9547 12.9702 14.9533 12.9845 14.9519C13.074 14.9431 13.1472 14.9359 13.2083 14.9294C13.1608 14.8829 13.1025 14.8269 13.0298 14.7571L11.8049 13.5829ZM8.98345 14.1665L8.95833 14.1424L8.93322 14.1665C7.90926 14.1531 7.08333 13.3188 7.08333 12.2917C7.08333 11.2561 7.9228 10.4167 8.95833 10.4167C9.99387 10.4167 10.8333 11.2561 10.8333 12.2917C10.8333 13.3188 10.0074 14.1531 8.98345 14.1665ZM7.84296 15.2117L6.64008 16.365C6.5334 16.4672 6.45761 16.5397 6.39845 16.5935C6.39085 16.5304 6.38237 16.4516 6.37157 16.3502C6.3701 16.3364 6.36864 16.3224 6.36715 16.3081C6.35127 16.155 6.33245 15.9738 6.26925 15.8101C6.12927 15.4476 5.83756 15.1738 5.47793 15.0461C5.31598 14.9887 5.13676 14.9715 4.97544 14.956C4.96087 14.9547 4.94644 14.9533 4.93219 14.9519C4.84267 14.9431 4.76944 14.9359 4.70837 14.9294C4.75584 14.8829 4.81413 14.8269 4.88689 14.7571L6.11173 13.5829C6.45054 14.3286 7.0738 14.9178 7.84296 15.2117ZM5.83333 3.95833C5.83333 3.61316 6.11316 3.33333 6.45833 3.33333H11.4583C11.8035 3.33333 12.0833 3.61316 12.0833 3.95833C12.0833 4.30351 11.8035 4.58333 11.4583 4.58333H6.45833C6.11316 4.58333 5.83333 4.30351 5.83333 3.95833ZM4.16667 6.875C4.16667 6.52982 4.44649 6.25 4.79167 6.25H13.125C13.4702 6.25 13.75 6.52982 13.75 6.875C13.75 7.22018 13.4702 7.5 13.125 7.5H4.79167C4.44649 7.5 4.16667 7.22018 4.16667 6.875Z" fill="white"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="clear" v-if="!isMobileWindow()" />
    <!-- <UpdateBanner/> -->
    <UpdateBanner v-if="$store.state.checkAutoUpdate"/>

    </header>
</template>

<script>
import UpdateBanner from "@/components/layout/modals/UpdateBanner.vue";
import CustomDropdown from "@/components/layout/elements/CustomDropdown.vue";
import axios from 'axios';
import LogoImg from '@/assets/images/logo.png';
export default {
  name: "Header",
  components: {
    UpdateBanner,
    CustomDropdown
  },
  data(){
    return{
      progress:[
        {
          data_label: 'user_trainings_started', cf: 2.512, description:'header.started_trainings'
        },
        {
          data_label: 'user_trainings_ended', cf: 2.512, description:'header.finished_trainings'
        }, 
        {
          data_label: 'user_test_average', cf: 2.512, description:'header.test_average'
        }
      ],
      selectedLMS: {},
    }
  },
  watch: {
    '$store.state.currentLMS'() {
      let index = this.$store.state.connectedLMSes.findIndex((lms) => lms.lms_key == this.$store.state.currentLMS);
      if (index != -1) {
        this.selectedLMS = this.$store.state.connectedLMSes[index];
      }
    },
    '$store.state.connectedLMSes.length'() {
       let index = this.$store.state.connectedLMSes.findIndex((lms) => lms.lms_key == this.$store.state.currentLMS);
      if (index != -1) {
        this.selectedLMS = this.$store.state.connectedLMSes[index];
      }
    }
  },
  mounted() {
     let index = this.$store.state.connectedLMSes.findIndex((lms) => lms.lms_key == this.$store.state.currentLMS);
      if (index != -1) {
        this.selectedLMS = this.$store.state.connectedLMSes[index];
      }
  },
  methods: {

    openCertificates() {
      this.$store.state.certificates.openCert();
    },
    closeMobileDrawers() {
      if (this.isMobileWindow()) {
        this.$store.state.certificates.closeCert();
        this.$store.state.side_open = false;
      }
    },
    replaceLogo(e){
      e.target.src = LogoImg
    },
    switchPlatform(platform) {
      let lms_key = platform;
      let platform_item = this.$store.state.connectedLMSes.find((p) => p.lms_key == lms_key);
      this.selectedLMS = platform_item;
      axios
        .get(`${this.$store.state.api_link}/switch/platform?lms_key=${lms_key}`)
        .then((res) => {
          let backend_domain = res.data.backend_domain;
          this.$store.state.loading.loadingStart();
          this.$store.commit("setNewUrl", backend_domain);
          // this.$store.commit("fetchSystemSettings");
          this.$store.state.currentLMS = lms_key;
         
          this.$store.state.pageRerenderKey++;
          this.$store.state.loading.loadingDone();
        })
        .catch((err) => {
          let index = this.$store.state.connectedLMSes.findIndex((lms) => lms.lms_key == lms_key);
          if (index != -1) {
            this.$store.state.connectedLMSes.splice(index, 1);
          }
        });
    },
    goToEditInfoPage(){
        this.$router.push('/settings')
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_progressbars.scss";
header {
    display: flex;
    align-items: center;
    background-color: #fff;
    position: fixed;
    z-index: 1000;
    width: 100%;
    transition: .5s top;
    top: 0;
    height: 15.56vh;
    max-height: 15.56vh;

    &.hidden {
      top: -15.56vh;
    }

    .logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      align-items: center;
        float: left;
        position: relative;

      a{
        display: flex;
        justify-content: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: initial;
        position: relative;
      }
        img {
            // width: 100%;
            // max-width: 10rem;
            max-height: 100%;
            padding: 2vh 8vh 2vh 5vh;
            max-width: 28vh;
        }
    }

    .vseperator {
      height: 8.5vh;
      margin-top: 1.25vh;
      float: left;
      width: 0.27vh;
      border-radius: 3px;
      
      background-color: var(--primary-color);
    }

    .results {
        float: left;
        margin-left: 75px;
        font-family: var(--main-site-font);;

        h2 {
            margin-bottom: 0;
            margin-top: 35px;
        }

        .result--score {
            width: 45px;
            font-weight: bold;
            display: inline-block;
            text-align: right;
            padding-right: 5px;
        }

        .result--text {
            display: inline-block;
        }
    }

    .person {
      float: left;
      margin: 15px 30px;

      .avatar {
        width: 72px;
        height: 72px;
        border-radius: 100%;
        background-size: cover;
        background-position: center;
        display: inline-block;
        vertical-align: middle;
      }

      .info {
        display: inline-block;
        vertical-align: middle;
        font-family: var(--main-site-font);;
        margin-left: 30px;
        line-height: 1;
        font-size: 16px;

        h3 {
          font-size: 20px;
          font-weight: bold;
          margin: 0;
          margin-bottom: 10px;
        }

        a {
          text-decoration: underline;
        }
      }
    }

    .documents {
      cursor: pointer;
      text-decoration: underline;
    }
    .progress--bar{
      .not-filled{
         stroke: var(--secondary-color);
         opacity: 0.5;
      }
      .filled{
        stroke: var(--secondary-color);
        // &.transition{
        //   transition: all 7.5s linear;
        // }
      }
    }
    .cert-button-container{
      .cert-button{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2rem;
        width: 2rem;
        background: #C89EFF;
        border-radius: 50%;
        align-items: center;
        transition: 0.25s;
        min-width: 100%;
        box-shadow: 0px 2px 6px 2px rgba(47, 37, 93, 0.15);
        filter: drop-shadow(0px 1px 2px rgba(47, 37, 93, 0.2));
        transition: transform 0.3s ease;
        &:hover{
          background-color: #C89EFF;
          transform: scale(1.1);
        }
        &:active{
          background: #C89EFF;
          transform: scale(0.95);

        }
        cursor: pointer;
        
      }
    }
}
.user-info-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    .user-info-wrapper{
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    .edit-info{
        cursor: pointer;
    }
    .user-name{
        font-weight: bold;
        font-size: clamp(14px, 1vw, 20px);
        font-family: 'Lato', var(--main-site-font);
        color: #0A1929;
    }
    .user-email{
        font-family: 'Lato', var(--main-site-font);
        font-size: clamp(12px, 1vw, 16px);
        color: rgba(10, 25, 41, 0.85);
    }
}
.search--wrapper {
    position: fixed;
    left: 0;
    top: 1.5rem;
    right: 0;
    margin: auto;
    display: flex;
    width: fit-content;

    .search {
      background-color: #efefef;
      border-radius: 10px;
      display: inline-block;
      padding: 10px;

      input {
        vertical-align: middle;
        outline: none;
        border: none;
        font-size: 15px;
        padding: 0 10px;
         background-color: #efefef;
        -webkit-user-select: text;
      }

      svg {
        vertical-align: middle;
        cursor: pointer;
        circle, line{
          stroke: var(--primary-color);
        }
      }
    }
    @media(max-width: 768px), (max-width: 1000px) and (max-height: 512px) {
      display: flex;
      height: 47px;
      margin: 0;
      position: relative;
      width: 100%;
      margin-right: 3.7rem;
      .search{
        width: 100%;
        display: flex;
        align-items: center;
        input{
          width: 100%;
        }
      }
    }
  }

@media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
  header{
    display: flex;
    
    .cert-button-container{
      display: none;
      max-width: 45vw;
      font-size: clamp(14px,0.8vw,18px);
      left: 0;
      right: 0;
      margin: auto;
        margin-right: auto;
      margin-right: 4rem;
      .cert-button{
        padding: 9px 10px;
        align-items: center;
      }
    }
    .logo{
      // max-width: 30%;
      //  align-items: center;
      a{
        display: flex;
        align-items: center;
      }
      img{
        padding: 1rem 1rem;
        height: auto;
        justify-self: flex-start;
        object-fit: contain;
        max-width: 10rem;
        // min-height:initial;
      }
    }
    .vseperator{
      display: none;
    }
  }
}
@media (max-width: 1000px) and (max-height: 512px){
  header{
    .logo{
      img{
        padding: 0.5rem 1rem;
      }
    }
  }
}
.platform-switcher{
  margin: auto;
    margin-right: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.right-menu-section{
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 3vh;
    display: flex;
    align-items: center;
    gap: 24px;
}
.text-only{
  font-size: clamp(14px,1.5vw,16px);
  padding: 6px 8px;
  color: #333;
}
</style>
<style lang="scss">
.platform-switch-dropdown{
  background-color: white;
  box-shadow: 0 2px 2px 0px rgba(0,0,0,0.16);
  min-width: 132px;
  &.dropdown-container:not(.no-padding-no-bg){
    border:1px solid #EAEAEA;
    border-radius: 6px;
    padding: 6px 8px;
    background-color: white;
  }
  &.dropdown-container{
    .dropdown-extended .dropdown-option span{
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>